import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

import { EmissionsIcon } from '../../../../assets/svg/home-summary/EmissionsIcon';
import { WeightType } from '../../../../domain/driversProject/DriversProject';
import { kgToLb } from '../../../../helpers/Units';
import { Text } from '../../../../react-components/Text';

interface EmissionsSummaryProps {
  emissions?: number;
  units?: WeightType;
}

export const EmissionsSummary = ({ emissions, units = `kg` }: EmissionsSummaryProps) => {
  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      wrap="nowrap"
      style={{ width: `18%`, position: `absolute`, right: `24px`, marginTop: `26px` }}
    >
      <EmissionsIcon />

      <Text variant="h6" style={{ color: RoutalPalette.white, marginTop: `6px` }}>
        {`${kgToLb(emissions ?? 0, units)} ${units}`}
      </Text>

      <Text
        variant="small"
        style={{ color: RoutalPalette.white }}
        intlId="drivers.home_analytics_summary.co2_emissions"
      />
    </Grid>
  );
};
